<template>
  <div class="wishlist">
    <SfTabs :open-tab="1">
      <SfTab :title="$t('Shopping List')">
        <ShoppingList :list="shoppingList" />
      </SfTab>
    </SfTabs>
  </div>
</template>

<script>
import { SfTabs } from '@storefront-ui/vue';
import user from '../../mixins/user';
import ShoppingList from '../ShoppingList.vue';

export default {
  name: 'MyWishlist',
  mixins: [user],
  components: {
    SfTabs,
    ShoppingList,
  },
  created() {
    this.fetchShoppingList();
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint";
</style>
